import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCampaignParticipantsStore = defineStore('campaignParticipants', () => {
  const hasUpdates = ref(false)

  const setHasUpdates = (value: boolean) => {
    hasUpdates.value = value
  }

  return {
    hasUpdates,
    setHasUpdates,
  }
})
